import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

export const roleGuard = (allowedRoles: string[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const userRole = authService.user()?.role;

    if (userRole && allowedRoles.includes(userRole)) {
      return true;
    }

    return router.parseUrl('/dashboard');
  };
};
